import * as React from "react";
import { Image } from "@grandvisionhq/common";
/* empty css                    */
const StoreTileImage = ({ className, alt, url, ...rest }) => /* @__PURE__ */ React.createElement("div", { className: "store-tile__image-wrapper" }, /* @__PURE__ */ React.createElement(Image, { ...rest, alt, url, className: "store-tile__image", cover: true }));
export {
  StoreTileImage as default
};
//# sourceMappingURL=StoreTileImage.js.map
